import React from "react";
import { View, Text, Image, StyleSheet } from "react-native";
import { connect } from "react-redux";
import TouchableRipple from '@mmt/legacy-commons/Common/Components/TouchableRipple.ios';
import { colors } from '@mmt/legacy-commons/Styles/globalStyles';
import { getRailsLanguageByKey, shouldShowHindiTooltip } from "../../vernacular/AppLanguage";
const changeLangIcon = require('@mmt/legacy-assets/src/LanguageSwitcher.webp');
import get from "lodash/get";
import { updateRailsLang } from "../../vernacular/vernacularActions";
import ToolTipCustomizable from './ToolTipCustomizable';
import {fontStyle} from "../../vernacular/VernacularUtils";
import {trackLanguageSwitch} from "../../vernacular/tracking";
import { isPhonePePlatform } from '../../Utils/RisUtils';

const styles = StyleSheet.create({
  button: {
    justifyContent: 'center',
    marginVertical: 4,
    backgroundColor: colors.white,
  },
  changeLanguageContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 10,
    zIndex: 10,
    elevation: 10,
    backgroundColor: colors.lighterBlue,
    borderRadius: 5,
    height: 50,
    marginVertical: 4,
    marginRight: 10,
    width: 40,
    boxSizing: 'border-box',
  },
  fullWidthIcon: {
    flexDirection: "row",
    width: 65,
    height: 30,
    paddingHorizontal: 5,
    paddingVertical: 8,
    borderRadius: 20,
  },
  changeLanguageIcon: {
    height: 16,
    width: 21,
    marginRight: 1,
  },
  changeLanguageLabel: {
    fontSize: 13,
    padding: 2,
    color: colors.azure,
  },
  railsHindiToolTipContentStyle : {
    paddingHorizontal : 10,
    marginHorizontal : 'auto',
    marginVertical: 'auto'
  },
  railsHindiToolTipTextStyle : {
    fontSize : 12,
    color : colors.white
  },
  railsHindiToolTipTipStyle : {
    marginLeft : 'auto',
    marginRight : 'auto'
  },
});


function LanguageSwitcher({
  fullWidthIcon,
  lang,
  toggleLanguge,
  showHindiTooltip,
  isSeo = false,
  pageId,
}) {
  if (isPhonePePlatform()) {
    return null;
  }
  const [showTooltip, setTooltipVisibility] = React.useState(true);

  const hideTooltip = () => setTooltipVisibility(false);

  return (
    <>
      <TouchableRipple
        onPress={() => {
          toggleLanguge(pageId, lang);
        }}
        style={StyleSheet.flatten(styles.button)}>
        <View style={[
          styles.changeLanguageContainer,
          fullWidthIcon && styles.fullWidthIcon,
        ]}>
          <Image style={styles.changeLanguageIcon} source={changeLangIcon} />
          <Text style={[styles.changeLanguageLabel, fontStyle("bold")]}>
            {getRailsLanguageByKey("altLabel")}
          </Text>
        </View>
      </TouchableRipple>
      {
        showTooltip && showHindiTooltip &&  shouldShowHindiTooltip(isSeo) &&
        <ToolTipCustomizable
          style={{
            position: 'absolute',
            width: 130,
            top: 50
          }}
          orientation={"top"}
          content="अब हिन्दी में भी उपलब्ध"
          contentStyle={styles.railsHindiToolTipContentStyle}
          textStyle={styles.railsHindiToolTipTextStyle}
          tipStyle={styles.railsHindiToolTipTipStyle}
          dismiss
          hideFunction={hideTooltip}
        >
        </ToolTipCustomizable>
      }
    </>
  )
}

const mapStateToProps = (state) => {
  const lang = get(state, "railsVernacular.lang", "");
  return {
    lang
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleLanguge: (pageName, fromLang) => {
      const toLang = getRailsLanguageByKey("altLang");
      trackLanguageSwitch({pageName, fromLang, toLang});
      dispatch({
        type: 'RESET_REDUX',
      })
      dispatch(updateRailsLang(toLang));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSwitcher);
